import { AsyncSelectQueryFieldProps, SelectField } from 'components/form'
import { ViaAdministracaoSelectFieldDocument } from 'graphql/hooks.generated'
import { ViaAdministracaoSelectFieldQuery, ViaAdministracaoSelectFieldQueryVariables } from 'graphql/types.generated'
import React from 'react'

import { DEFAULT_SELECT_SIZE, useAsyncQuerySelect } from '../useAsyncQuerySelect'

export interface ViaAdministracaoSelectModel {
  id: ID
  nome: string
}

export interface ViaAdministracaoSelectFieldProps
  extends AsyncSelectQueryFieldProps<
    ViaAdministracaoSelectModel,
    ViaAdministracaoSelectFieldQuery,
    ViaAdministracaoSelectFieldQueryVariables
  > {}

export function ViaAdministracaoSelectField(props: ViaAdministracaoSelectFieldProps) {
  const extractItems = (data: ViaAdministracaoSelectFieldQuery) => {
    return data?.aplicacoesMedicamento?.content
  }

  const handleItemToString = (item: ViaAdministracaoSelectModel) => {
    return item?.nome
  }

  const variables = (inputQuery: string): ViaAdministracaoSelectFieldQueryVariables => ({
    input: {
      query: inputQuery,
      pageParams: {
        size: DEFAULT_SELECT_SIZE,
      },
    },
  })

  const { ...asyncProps } = useAsyncQuerySelect<
    ViaAdministracaoSelectModel,
    ViaAdministracaoSelectFieldQuery,
    ViaAdministracaoSelectFieldQueryVariables
  >({
    query: ViaAdministracaoSelectFieldDocument,
    extractItems,
    variables,
  })

  return <SelectField<ViaAdministracaoSelectModel> itemToString={handleItemToString} {...asyncProps} {...props} />
}
